import React from "react";

export const PageFooter = () => (
  <footer className="footer">
    <div className="content has-text-centered">
      <p>Copyright &copy; 2013-2019 Septagon All rights reserved.</p>
    </div>
  </footer>
);
